import { render, staticRenderFns } from "./SOVall.vue?vue&type=template&id=5ab56e5f&scoped=true"
import script from "./SOVall.vue?vue&type=script&lang=js"
export * from "./SOVall.vue?vue&type=script&lang=js"
import style0 from "./SOVall.vue?vue&type=style&index=0&id=5ab56e5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab56e5f",
  null
  
)

export default component.exports